import React from 'react';
import TextArea from '../../forms/TextArea';
import Input from '../../forms/Input';

const SendEmailInputs = ({ data, onInput }) => 
    <React.Fragment>
        <div className="ckp-admin-grid-column">
            <Input 
                label="Subject"
                className="is-full-width"
                value={data.subject}
                onChange={onInput}
                disabled={false}
                name='subject'
            />
            <TextArea
                label="Message"
                className="is-full-width"
                value={data.text}
                onChange={onInput}
                disabled={false}
                name='text'
            />
        </div>
    </React.Fragment>;

export default SendEmailInputs;



// WEBPACK FOOTER //
// ./src/components/admin/lineup/SendEmailInputs.js